// @flow
import { useState, useEffect } from "react";
import { apiCall } from "../common/fetch";

function mapStockHistoryToPoints(history) {
  if (history == null) {
    return [];
  }

  const dates = Object.keys(history);
  let points = [];

  for (let date of dates) {
    // HACK: Чиним формат дат чтобы они корректно парсились в сафари
    const correctDate = new Date(`${date.replace(" ", "T")}+00:00`).valueOf();

    points.push({
      date: correctDate,
      value: Number(history[date])
    });
  }

  return points;
}

function fetchRecentHistory(stock) {
  return apiCall(`/ajax/stockHistory?stock=${stock}&limit=${7200}&tz=UTC`)
    .then(r => r.json())
    .then(mapStockHistoryToPoints);
}

function flip(points) {
  let base = points[0];
  return points.map(point => {
    return {
      date: point.date,
      value: base.value + (base.value - point.value)
    };
  });
}

export function useGenerativeData(
  ref,
  { stock, isRunning, deals, next, attempt }
) {
  // Курсор — это индекс в истории, на котором мы сейчас находимся
  let [cursor, setCursor] = useState(0);

  // Курсор будет плюсоваться в секундном интервале, но только когда isRunning
  useEffect(
    () => {
      if (isRunning) {
        let interval = setInterval(() => {
          setCursor(c => c + 1);
        }, 1000);
        return () => {
          clearInterval(interval);
        };
      }
    },
    [isRunning]
  );

  // isReady нужен чтобы не оперировать над историей пока её нет.
  let [isReady, setIsReady] = useState(false);
  let [fullHistory, setFullHistory] = useState(null);

  // Безопасный запас истории — максимум по 30 сек на каждую сделку, а их две.
  let safeHistoryStash = 30 + 2;

  // Эффект запроса истории
  useEffect(
    () => {
      fetchRecentHistory(stock).then(history => {
        setFullHistory(history);
        setCursor(history.length - 1 - safeHistoryStash);
        setIsReady(true);
      });
    },
    [stock, attempt]
  );

  // Вызываем следующий шаг когда время сделки подходит к концу. Надеемся на то,
  // что это приведёт к isRunning === false, иначе всё развалится!
  useEffect(
    () => {
      switch (deals.length) {
        case 0:
          break;
        case 1: {
          if (
            cursor ===
            fullHistory.length - 1 - safeHistoryStash + deals[0].bTime + 3
          ) {
            next();
          }
          break;
        }
        case 2: {
          if (
            cursor ===
            fullHistory.length - 1 - safeHistoryStash + deals[1].bTime + 3
          ) {
            next();
          }
          break;
        }
        default:
          break;
      }
    },
    [deals, cursor]
  );

  // Самое интересное: при сдвиге курсора надо собрать точки, да так чтобы
  // клиент 100%  победил.
  useEffect(
    () => {
      if (!isReady) {
        return void 0;
      }

      let past = fullHistory.slice(
        0,
        fullHistory.length - 1 - safeHistoryStash
      );

      let game = [];

      switch (deals.length) {
        case 0: {
          ref.current = past;
          break;
        }
        case 1: {
          let direction0 = deals[0].bidType ? "UP" : "DOWN";

          let deal0start =
            fullHistory[fullHistory.length - 1 - safeHistoryStash];
          let deal0end =
            fullHistory[
              fullHistory.length - 1 - safeHistoryStash + deals[0].bTime
            ];

          game = fullHistory.slice(
            fullHistory.length - 1 - safeHistoryStash,
            cursor
          );

          if (deal0start.value > deal0end.value) {
            if (direction0 === "UP") {
              game = flip(game);
            }
          } else {
            if (direction0 === "DOWN") {
              game = flip(game);
            }
          }

          ref.current = [...past, ...game];

          break;
        }
        case 2: {
          let direction0 = deals[1].bidType ? "UP" : "DOWN";

          let deal0start =
            fullHistory[fullHistory.length - 1 - safeHistoryStash];
          let deal0end =
            fullHistory[
              fullHistory.length - 1 - safeHistoryStash + deals[1].bTime
            ];

          game = fullHistory.slice(
            fullHistory.length - 1 - safeHistoryStash,
            cursor
          );

          if (deal0start.value > deal0end.value) {
            if (direction0 === "UP") {
              game = flip(game);
            }
          } else {
            if (direction0 === "DOWN") {
              game = flip(game);
            }
          }

          ref.current = [...past, ...game];

          break;
        }
        default: {
          ref.current = past;
          break;
        }
      }
    },
    [cursor, isReady, fullHistory]
  );
}



// WEBPACK FOOTER //
// ./src/components/Tour/useGenerativeData.js